'use client';
import styles from './panelMenu.module.scss';
import { Button, message, Switch } from 'antd';
import { FiUser } from 'react-icons/fi';
import { useContext } from 'react';
import { GlobalContext } from 'context';
import { AppContextActionKeyEnum, APPlicationStoreEnum, ThemeEnum } from 'types';
import { COLORS } from 'utilities';
import { CopyToClipboard, isAppInstalled, RestAPI } from 'scripts';
import { API, PATH } from 'data';
import { CiCircleAlert } from 'react-icons/ci';
import { NavLink } from 'react-router-dom';
import { AppLinkComp } from 'components';
import { __AppStorage as AppStorage } from 'scripts/storage';
import useAsyncClick from 'scripts/useAsyncClick';
import { useRouter } from 'next/navigation';
import { PiUserListDuotone } from 'react-icons/pi';
import { ImClock2 } from 'react-icons/im';
import { FaBookmark, FaShareAlt } from 'react-icons/fa';
import { MdOutlineHelp, MdOutlinePhone } from 'react-icons/md';
import { RiCustomerService2Fill } from 'react-icons/ri';
import { IoSunny } from 'react-icons/io5';
import { TbDownload } from 'react-icons/tb';
import Mojavez from 'assets/images/leagals/mojavez-ir.svg';
import IranianAsnaf from 'assets/images/leagals/iranianasnaf';
import Image from 'next/image';

function PanelMenuComp({ onLogout }: { onLogout: () => void }) {
    const router = useRouter();
    const { theme, update, profile } = useContext(GlobalContext);
    const onThemeChange = () => {
        const newValue = theme === ThemeEnum.dark ? ThemeEnum.light : ThemeEnum.dark;
        update({ key: AppContextActionKeyEnum.theme, value: newValue });
        document.body.setAttribute('data-mode', newValue);
        RestAPI.post(API.middlewares.theme, { theme: newValue });
    };

    const shareHandler = () => {
        CopyToClipboard(window.location.origin + PATH.download + '?source=' + APPlicationStoreEnum.cafebazar);
        if (navigator.share) {
            try {
                navigator.share({
                    title: 'تیک سبز',
                    url: window.location.origin + PATH.download + '?source=' + APPlicationStoreEnum.cafebazar,
                });
            } catch {
                console.log('share error');
            }
        }
        message.success('لینک سایت تیک سبز با موفقیت در کلیپ بوردتان ذخیر شد');
    };

    const logoutHandler = useAsyncClick(() => {
        return new Promise((resolve) =>
            RestAPI.post(API.middlewares.logout, {})
                .then(() => {
                    AppStorage.authToken.remove();
                    update({ key: AppContextActionKeyEnum.profile, value: undefined });
                    router.push(PATH.home);
                    onLogout();
                })
                .catch(() => message.error('خطایی در خروج شما از حساب کاربری تان رخ داده است. لطفا بعدا تلاش کنید.'))
                .then(() => resolve(true)),
        );
    });

    return (
        <div className={`${styles['menu-layout']} w-100 d-flex flex-column`}>
            <div className={`${styles['header-mobile']}`}>
                <div className={`${styles['menu-item']} flex center-content-y justify-content-between`}>
                    <div className="d-flex center-content-y g-1">
                        <FiUser size={20} color={theme === ThemeEnum.light ? COLORS.black : COLORS.gray2} />
                        <p className="t-p2 t-400 t-l-black1">{profile?.phone}</p>
                    </div>
                    <Button {...logoutHandler} type="primary" className={`${styles['logout-btn']}`}>
                        <p className="t-p3 t-400 t-primary-i">خروج</p>
                    </Button>
                </div>
                <p className="t-primary-i t-p3 g-1 d-md-none">
                    <CiCircleAlert size={18} color={COLORS.primary} />
                    اطلاعات تماس بر روی آگهی های شما با این شماره ثبت می شوند
                </p>
            </div>
            <NavLink
                to={PATH.panel.myAds.index()}
                className={({ isActive }) => (isActive ? styles['menu-item-active'] : '')}
            >
                <div className={`${styles['menu-item']}  flex center-content-y justify-content-between`}>
                    <div className="d-flex center-content-y g-1">
                        <PiUserListDuotone size={20} color={COLORS.primary} />
                        <p className={`${styles['title']} t-p2 t-400 t-l-black1`}>فروشگاه من</p>
                    </div>
                </div>
            </NavLink>
            <NavLink to={PATH.panel.views()} className={({ isActive }) => (isActive ? styles['menu-item-active'] : '')}>
                <div className={`${styles['menu-item']}  flex center-content-y justify-content-between`}>
                    <div className="d-flex center-content-y g-1">
                        <ImClock2 size={20} color={COLORS.primary} />
                        <p className={`${styles['title']} t-p2 t-400 t-l-black1`}>بازدید ها من</p>
                    </div>
                </div>
            </NavLink>
            <NavLink
                to={PATH.panel.bookmarks()}
                className={({ isActive }) => (isActive ? styles['menu-item-active'] : '')}
            >
                <div className={`${styles['menu-item']}  flex center-content-y justify-content-between`}>
                    <div className="d-flex center-content-y g-1">
                        <FaBookmark size={20} color={COLORS.primary} />
                        <p className={`${styles['title']} t-p2 t-400 t-l-black1`}>آگهی های نشان شده</p>
                    </div>
                </div>
            </NavLink>
            <AppLinkComp href={PATH.aboutUs}>
                <div className={`${styles['menu-item']} flex center-content-y justify-content-between`}>
                    <div className="d-flex center-content-y g-1">
                        <MdOutlineHelp size={20} color={COLORS.primary} />
                        <p className={`${styles['title']} t-p2 t-400 t-l-black1`}>درباره تیک سبز</p>
                    </div>
                </div>
            </AppLinkComp>
            <AppLinkComp href={PATH.contactUs}>
                <div className={`${styles['menu-item']} flex center-content-y justify-content-between`}>
                    <div className="d-flex center-content-y g-1">
                        <MdOutlinePhone size={20} color={COLORS.primary} />
                        <p className={`${styles['title']} t-p2 t-400 t-l-black1`}>تماس با ما</p>
                    </div>
                </div>
            </AppLinkComp>
            <NavLink
                to={PATH.panel.tickets.index()}
                className={({ isActive }) => (isActive ? styles['menu-item-active'] : '')}
            >
                <div className={`${styles['menu-item']}  flex center-content-y justify-content-between`}>
                    <div className="d-flex center-content-y g-1">
                        <RiCustomerService2Fill size={20} color={COLORS.primary} />
                        <p className={`${styles['title']} t-p2 t-400 t-l-black1`}>پشتیبانی تیک سبز</p>
                    </div>
                </div>
            </NavLink>
            <div className={`${styles['menu-item']} center-content-y justify-content-between`}>
                <div className="d-flex center-content-y g-1">
                    <IoSunny size={20} color={COLORS.primary} />
                    <p className={`${styles['title']} t-p2 t-400 t-l-black1`}>
                        {theme === ThemeEnum.dark ? 'حالت روز' : 'حالت شب'}
                    </p>
                </div>
                <Switch onChange={onThemeChange} value={theme === ThemeEnum.light ? true : false} />
            </div>
            <AppLinkComp href={PATH.download} className={isAppInstalled() ? 'd-none' : ''}>
                <div className={`${styles['menu-item']}  flex center-content-y justify-content-between bg-primary-i`}>
                    <div className="d-flex center-content-y g-1">
                        <TbDownload size={20} color={COLORS.white} />
                        <p className={`${styles['title']} t-p2 t-400 t-white-i`}>دریافت اپلیکیشن</p>
                    </div>
                </div>
            </AppLinkComp>
            <div
                className={`${styles['menu-item']} pointer center-content-y justify-content-between`}
                onClick={shareHandler}
            >
                <div className="d-flex center-content-y g-1">
                    <FaShareAlt size={20} color={COLORS.primary} />
                    <p className={`${styles['title']} t-p2 t-400 t-l-black1`}>اشتراک گذاری تیک سبز</p>
                </div>
            </div>
            <div className={`${styles.licences} d-md-none`}>
                <div style={{ maxWidth: 120 }}>
                    <a
                        style={{ width: '100%', height: '100%', display: 'flex' }}
                        referrerPolicy="origin"
                        target="_blank"
                        href="https://trustseal.enamad.ir/?id=735735&Code=Xhki7ddrJyuZZ9Kcb0Mf0bIn1hY2JmbU"
                    >
                        <img
                            {...{ code: 'Xhki7ddrJyuZZ9Kcb0Mf0bIn1hY2JmbU' }}
                            referrerPolicy="origin"
                            src="https://trustseal.enamad.ir/logo.aspx?id=735735&Code=Xhki7ddrJyuZZ9Kcb0Mf0bIn1hY2JmbU"
                            alt=""
                            style={{ cursor: 'pointer' }}
                        />
                    </a>
                </div>
                <div className="d-none">
                    <a href="https://apinovin.iranianasnaf.ir/parvaneh/7b5ae770-4486-4f9d-ac8a-5348977da78b/html">
                        <img
                            src={IranianAsnaf}
                            alt="Iranian Asnaf"
                            style={{ width: '100%', height: '100%', display: 'flex' }}
                        />
                    </a>
                </div>
                <div className="d-none">
                    <a
                        href="https://qr.mojavez.ir/track/15658225"
                        style={{ width: '100%', height: '100%', display: 'flex' }}
                    >
                        <Image src={Mojavez} alt="Mojavez" />
                    </a>
                </div>
            </div>
        </div>
    );
}

export default PanelMenuComp;
